import React from "react";
import { Link } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { AiFillDashboard, AiOutlineRight } from 'react-icons/ai';
import PropTypes from 'prop-types';

const StatsCard = ({ value, label, color, url }) => {
  return (
    <Card className="dash-card">
      <Link to={url} className="text-decoration-none">
        <CardBody>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div className="d-flex align-items-center">
              <AiFillDashboard className={`me-3 text-${color}`} style={{ fontSize: '24px' }} />
              <h5 className="mb-0">{label}</h5>
            </div>
          </div>
          <div className="text-muted">
            <div className="d-flex justify-content-between align-items-center">
              <p className="mb-0 font-weight-bold">{value}</p>
              {url && (<Link to={url} className={`text-${color} font-weight-bold`}>
                Details <AiOutlineRight style={{ fontSize: '15px', verticalAlign: 'text-bottom', marginLeft: '5px' }} />
              </Link>)}
            </div>
          </div>
        </CardBody>
      </Link>
    </Card>
  );
};

StatsCard.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}


export default StatsCard;
